module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img_4.3d00e431.png";